import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "system-menu-dialog-container" }
const _hoisted_2 = { class: "dialog-footer" }

import {ref, reactive, computed, onMounted} from 'vue';
import {useStore} from 'vuex'
import {ElMessage} from 'element-plus';
import apis from '@/apis';
// 引入组件
import Pagination from './Pagination.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LogDialog',
  setup(__props, { expose: __expose }) {

const store = useStore()
console.log(store.state)

const commonLog = computed(() => {
  console.log('commonLog更新', store.state.commonLog)
  return store.state.commonLog
})
const log = computed(() => {
  console.log(store.state.log, '===')
  return store.state.log
})
// const visiable = computed(() => {
//     console.log(store.state.commonLog.visiable,'visiable更新===------')
//     return store.state.commonLog.visiable
// })
const user = computed(() => {
  console.log(store.state.user, 'user更新===------')
  return store.state.user
})

const state = reactive({
  listQuery: {
    page: 1,
    perPage: 10
  },
  visiable: false,
  tableData: []
});

const triggDialog = () => {
  state.visiable = !state.visiable
}
/**
 * 弹窗隐藏
 */
const closeDialog = () => {
  store.commit('log/triggle', false)
}

/**
 * 请求数据
 */
const getTableData = () => {
  store.dispatch('log/getLogs')
}
onMounted(async () => {
  console.log('logs mounted')

})


__expose({
  triggDialog
})



return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      title: "日志",
      width: "840px",
      modelValue: log.value.visible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((log.value.visible) = $event)),
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: closeDialog,
            size: "default"
          }, {
            default: _withCtx(() => [
              _createTextVNode("关闭")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: log.value.logs.list,
          border: "",
          stripe: "",
          "row-key": "path",
          "tooltip-options": {effect: 'light', placement: 'bottom'},
          "tree-props": { children: 'children', hasChildren: 'hasChildren' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "created_at",
              label: "时间",
              width: "160"
            }),
            _createVNode(_component_el_table_column, {
              prop: "staff.name",
              label: "操作人",
              width: "120"
            }),
            _createVNode(_component_el_table_column, {
              prop: "action",
              label: "操作类型",
              width: "110"
            }),
            _createVNode(_component_el_table_column, {
              prop: "content",
              label: "操作内容",
              "show-overflow-tooltip": ""
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _withDirectives(_createVNode(Pagination, {
          total: log.value.logs.total,
          "current-page": log.value.logs.page,
          "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((log.value.logs.page) = $event)),
          "page-size": log.value.logs.perPage,
          "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((log.value.logs.perPage) = $event)),
          onPagination: getTableData
        }, null, 8, ["total", "current-page", "page-size"]), [
          [_vShow, log.value.logs.total>0]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})